import { jsxs, jsx } from 'react/jsx-runtime';
import { isPresetGradientColor } from '@flex-design-system/fx-colors';
import { forwardRef } from 'react';
import { getColor } from '../utils/color.mjs';
import useId from './hooks/useId.mjs';
import { getID, FlexLinearGradient } from './shared/FlexLinearGradient.mjs';

const ArticlePlusIcon = forwardRef(
  ({
    color: rawColor = "currentColor",
    size: sizeFromProps,
    type = "default",
    style,
    ...props
  }, forwardedRef) => {
    const { id } = useId();
    const isGradient = isPresetGradientColor(rawColor);
    const color = isGradient ? `url(#${getID(rawColor, id)})` : getColor(rawColor);
    const size = sizeFromProps ?? 24;
    if (type === "fill") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "m4 20.182.809.818h14.382l.809-.818V8.364l-.237-.579L15.27 3.24 14.697 3H4.809L4 3.818v16.364ZM15.46 5.684V7.59h1.886l-1.885-1.907ZM12.81 9.273v2.818h2.787v1.636h-2.787v2.818h-1.618v-2.818H8.405v-1.636h2.786V9.273h1.618Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    if (type === "default") {
      return /* @__PURE__ */ jsxs(
        "svg",
        {
          xmlns: "http://www.w3.org/2000/svg",
          width: size,
          height: size,
          fill: "none",
          viewBox: "0 0 24 24",
          ...props,
          ref: forwardedRef,
          style: sizeFromProps !== void 0 ? { width: size, height: size, flexShrink: 0, ...style } : { flexShrink: 0, ...style },
          children: [
            isGradient && /* @__PURE__ */ jsx(FlexLinearGradient, { id }),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M12.809 13.727v2.818h-1.618v-2.818H8.405v-1.636h2.786V9.273h1.618v2.818h2.787v1.636h-2.787Z"
              }
            ),
            /* @__PURE__ */ jsx(
              "path",
              {
                fill: color,
                d: "M4.809 21 4 20.182V3.818L4.809 3h9.888l.572.24 4.494 4.545.237.579v11.818l-.809.818H4.809Zm.809-16.364v14.728h12.764V9.135h-3.685l-.764-.772V4.636H5.618Zm11.665 2.955L15.46 5.748V7.59h1.822Z",
                fillRule: "evenodd",
                clipRule: "evenodd"
              }
            )
          ]
        }
      );
    }
    console.error(
      `ArticlePlusIcon doesn't support the combination of ${size} and ${type}`
    );
    return null;
  }
);

export { ArticlePlusIcon };
//# sourceMappingURL=ArticlePlusIcon.mjs.map
